import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  LoaderFunctionArgs,
  useLoaderData,
  useNavigate,
} from "react-router-dom";

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url);
  const success = url.searchParams.get("success") === "true";

  const icon = success
    ? "/images/ConfirmedIcon.svg"
    : "/images/RefusedIcon.svg";

  return { success, icon };
};

type Loader = Awaited<ReturnType<typeof loader>>;

export const ModalCancelResult = () => {
  const navigate = useNavigate();
  const { success, icon } = useLoaderData() as Loader;

  return (
    <Dialog open onOpenChange={() => navigate(-2)}>
      <DialogContent className="p-0 max-w-[530px]" showCloseButton={false}>
        <DialogHeader className="text-center items-center justify-center">
          <img className="pt-6" src={icon} />

          <DialogTitle className="text-xl text-bg-black font-medium leading-7 pt-3">
            {success ? "Sucesso!" : "Erro!"}
          </DialogTitle>
          <DialogDescription className="px-6 mt-0 text-center text-sm text-gray-500 font-light">
            {success
              ? "O License Fee e seus pagamentos foram cancelados com sucesso."
              : "Infelizmente, não foi possível cancelar o License Fee. Tente novamente mais tarde."}
          </DialogDescription>
        </DialogHeader>
        <div className="flex items-center space-x-2">
          <div className="grid flex-1 gap-2">
            <div className="pt-0 pb-6">
              <div className="px-6 pt-2">
                <div className="flex flex-col">
                  <Button
                    type="button"
                    className="min-h-[40px]"
                    onClick={() => navigate(-2)}
                  >
                    Fechar
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
